// action-types.js
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const ADD_ERROR_NOTIFICATION = 'ADD_ERROR_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
